import QrScanner from 'qr-scanner';
import React, { useEffect, useRef, useState } from 'react'
import { QrReader } from 'react-qr-reader';
import Webcam from "react-webcam";
import Qrscancamera from './Qrscancamera';
import { Button, Input, Select, Space } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { HashLoader, ClockLoader } from 'react-spinners';
import { Html5QrcodeScanner } from 'html5-qrcode';
import superagent from 'superagent';

const Qrscan1 = () => {

    const [scannedData, setScannedData] = useState(null)
    const [upiid, setupiid] = useState()
    const [upiidname, setupiidname] = useState()
    const [openbtn, setopenbtn] = useState(false)

    useEffect(() => {
        callforfetchoffers()
    }, [])

    const handleScanSuccess = (data) => {
        setScannedData(data);

        if (data?.includes('upi://')) {
            const sp1 = data?.split('pay?pa=')[1]
            const final = sp1?.split('&pn')[0]
            axios.post('https://vpavalidation.sabpaisa.in/VPA_VALIDATION/vpa/validate', { "vpa": final, "bankName": "AIRTEL" }).then((res) => {



                if (res?.data?.valid) {
                    setupiid(final)
                    setupiidname(res?.data?.payerName)


                } else {
                    alert('invalid upi id')
                }




            }).catch((e) => {
                alert('error on verify upi')
            })

            setupiid(final)

        }
    }

    const navigate = useNavigate()

    const callforfetchoffers = async () => {
        const result = await axios.get('https://reward-day-bg984.ondigitalocean.app/contact/trickoffers1011')
        setofferlist(result.data?.data?.tickets)

        // console.log(result.data?.data?.tickets,'hjasgd')
    }



    const [offerlist, setofferlist] = useState([])


    // const offerlist = [
    //     { id: 1, isfixed: false, name: 'Upstox - LC', partner: 'LC', tc: 'upstinst', po: 400, postback: 'https://lootcampaign.o18.click/p?o=21672118&m=7916&event=credit_approved&auth_token=ce82c12606&tid={clickid}', offerid: 27486 },
    //     { id: 2, isfixed: false, name: 'Angelone - LC', partner: 'LC', tc: 'Aone', po: 350, postback: 'https://lootcampaign.o18.click/p?o=21672118&m=7916&event=credit_approved&auth_token=ce82c12606&tid={clickid}', offerid: 73636 },

    //     { id: 3, isfixed: false, name: 'Airtel - LC', partner: 'LC', tc: 'Atl', po: 220, postback: 'https://lootcampaign.o18.click/p?o=21672118&m=7916&event=Register&auth_token=ce82c12606&tid={clickid}', offerid: 73690 },
    //     { id: 4, isfixed: false, name: 'Abgold - LC', partner: 'LC', tc: 'ab150', po: 100, postback: 'https://lootcampaign.o18.click/p?o=21672118&m=7916&event=credit_approved&auth_token=ce82c12606&tid={clickid}', offerid: 73691 },
    //     // { id: 3, isfixed: false, name: 'Nielsen - LC', partner: 'LC', tc: 'nsn3d', po: 140, postback: 'https://lootcampaign.o18.click/p?o=21672118&m=7916&event=credit_approved&auth_token=ce82c12606&tid={clickid}', offerid: 89084 },
    //     { id: 6, isfixed: false, name: 'Airtel - FC', partner: 'FC', tc: 'Air', po: 220, postback: 'https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/AccountWanderedSuccess?click={clickid}', offerid: 859843, goal: 'AccountWanderedSuccess' },

    //     { id: 7, isfixed: false, name: 'Bajaj - FC', partner: 'FC', tc: 'bdmt', po: 120, postback: 'https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/kyc?click={clickid}', offerid: 9843242, goal: 'kyc' },

    //     { id: 8, isfixed: false, name: 'Upstox - FC', partner: 'FC', tc: 'Up', po: 400, postback: 'https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/kyccompleted?click={clickid}', offerid: 928845, goal: 'kyccompleted' },

    //     { id: 9, isfixed: false, name: 'Angelone - FC', partner: 'FC', tc: 'One', po: 340, postback: 'https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/kycdone?click={clickid}', offerid: 929045, goal: 'kycdone' },

    //     // { id: 8, isfixed: false, name: 'Upstox - CL', partner: 'CL', tc: 'UP', po: 400, postback: 'https://cashlootcamps.com/acquisition/?security_token=vp41H2irdVsR&event_name=AccountOpenTracked&click_id={clickid}', offerid: 81, goal: 'AccountOpenTracked', code: 'itX6Jb' },

    //     // { id: 9, isfixed: false, name: 'NAVI - CL', partner: 'CL', tc: 'navi', po: 20, postback: 'https://cashlootcamps.com/acquisition/?security_token=vp41H2irdVsR&event_name=TransactionTracked&click_id={clickid}', offerid: 83, goal: 'TransactionTracked', code: 'lw8jFU' },

    //     //   { id: 9, name: 'creditmantri - CL', partner: 'CL', tc: 'credit', po: 14, postback: 'https://cashlootcamps.com/acquisition/?security_token=vp41H2irdVsR&event_name=Tracked&click_id={clickid}', offerid: 84, goal: 'Tracked',code:'pvOMaL' },

    //     // { id: 10, isfixed: true, name: 'incread - HQ', partner: 'HQ', tc: 'incred', po: 20, postback: 'https://sandboxads.fuse-cloud.com/pb?tid={clickid}&e_tkn=Gold_Silver_Successful_Purchase', offerid: 83, goal: 'TransactionTracked', code: 'lw8jFU' },
    //     // { id: 10, isfixed: false, name: 'incread - CM', partner: 'CM', tc: 'incred', po: 20, postback: 'https://sandboxads.fuse-cloud.com/pb?tid={clickid}&e_tkn=Gold_Silver_Successful_Purchase', offerid: 14557518, goal: 'Purchase', code: 'lw8jFU' },

    //     // { id: 7, name: 'Mobileexpr - FC', partner: 'FC', tc: 'mXpr', po: 150, postback: 'http://panel3.logicpay.in/api/v1/postback/e1cca49a-6e5c-415c-9728-ed6aeadd4981/retention?click={clickid}&pass=93nbs7373', offerid: 923045, goal: 'kycdone' },

    //     // { id: 15, isfixed: false, name: 'Airtel - CN', partner: 'CN', tc: 'Airtel', po: 220, postback: 'https://proproonline.cashnest.in/?click_id={clickid}&event=Account_Open&token=P360RqhwkwoeRQgTriaL', offerid: 585066541 },

    //     // { id: 16, name: 'Airtel - CG', partner: 'CG', tc: 'Airtel', po: 200, postback: 'https://partners.cashgullak.com/api/webhook/conversion?webhook_secret=cqUyz0Sg9G&click_id={clickid}&event=acc', offerid: 585066549, offer: 'sj7qfmttehipmyj' },

    //     // { id: 17, isfixed: true, name: 'StoryTV - CB', partner: 'CB', tc: 'Story-2', po: 25, postback: 'https://a2zf.com/track/track-event.asp?txnId={clickid}&event=424', },
    //     // { id: 18, isfixed: true, name: 'StoryTVnew - CB', partner: 'CB', tc: 'Story-New', po: 25, postback: 'https://a2zf.com/track/track-event.asp?txnId={clickid}&event=424', },
    //     // { id: 19, isfixed: true, name: 'Nielsen - CB', partner: 'CB', tc: 'Nielsen-Faro', po: 30, postback: 'https://zazzle83.trackier.co/acquisition?click_id={clickid}&security_token=ca0a013255aab56c4771', offerid: 740043 },
    //     // { id: 29, name: 'StoryTV2 - TM', partner: 'CB', tc: 'Story-3', po: 25, postback: 'https://a2zf.com/track/track-event.asp?txnId={clickid}&event=424', },

    // ]





    const [inputupi, setinputupi] = useState('')
    const [loadingupive, setloadingupive] = useState(false)



    const handleclickupiset = () => {
        axios.post('https://vpavalidation.sabpaisa.in/VPA_VALIDATION/vpa/validate', { "vpa": inputupi, "bankName": "AIRTEL" }).then((res) => {
            setloadingupive(true)

            if (res?.data?.valid) {
                setupiid(inputupi)
                setupiidname(res?.data?.payerName)
            } else {
                alert('invalid upi id')
            }
            setloadingupive(false)
        }).catch((e) => {
            alert('error on verify upi')
        })

    }

    const [isPolling, setIsPolling] = useState(false)
    const [count, setCount] = useState(0)
    const intervalRef = useRef(null)

    const [useramt, setuseramt] = useState()
    const [offerloading, setofferloading] = useState(false)
    const [processloading, setprocessloading] = useState(false)
    const [redirectionurls, setredirectionurls] = useState([])
    const [offerselctid, setofferselctid] = useState()
    const [postbackmsg, setpostbackmsg] = useState('')
    const [eventstatus, seteventstatus] = useState(false)
    const [sefclickid, setsefclickid] = useState()

    // console.log(redirectionurls)


    const handleofferchnage = async (e) => {
        setofferloading(true)
        seteventstatus(false)
        setofferselctid(e)
        const data = offerlist?.filter((vl) => vl?.id == e)[0]
        if (data?.partner == 'LC') {
            if (data?.tc == 'Aone') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)

                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinklc', { "user_custom": useramount, "refer_custom": refamt, "vpa": "betairoy@yvl", "selected": "Aone-175-175-21769172-true-1", "channelName": "", "channelLink": "", "payment_mode": "true" })

                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.url

                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/openreflinklc', { data: { "Cn": data?.tc, "vpa": upiid }, cookie: '_ga=GA1.1.1268484901.1765174581; __gsas=ID=7f316d6307f0a672:T=1765174580:RT=1765174580:S=ALNI_MY2rwK_HvSU2DKNTpVXDixP6K2iLQ; __tad=1765174629.2366981; _ga_9K8ZFE4KNV=GS2.1.s1765174580$o1$g1$t1765174656$j59$l0$h0; input=Pvzb9O2aVd2u0aNbg7hRXgAv%2BlJ7BmGHMURKYylIdzvbCXwgRM%2Ftqdxy9QMk4jn6lWjjS4IeuJWcchsjwwBsqWfS6BJlO3OGKxeD%2FTkFRL0s4LJTCMFanmWZKxslDSqO3f4N5hbJG3BlcOsHyfx3R5LeDxtwQ0gDqx0zQuhF98Zv089o%2BkilHJ037h7WzLz6TLh4pqOC%2BO%2FNWn0aUSrENjNuJZTRk58qbOq6qmiYOo19GK%2BUWW%2BvlIXwRZrh8l7YawmTiR%2F01sGxIlbFbG%2BvdFM7mheOI9C0wtGDOS6pqVY%3D; upi_id=' })

                    setredirectionurls(result1?.data?.data)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'Atl') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)

                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinklc', { "user_custom": useramount, "refer_custom": refamt, "vpa": "9266356727@ybl", "selected": "Atl-120-100-21393286-true-60", "channelName": "", "channelLink": "", "payment_mode": "true" })

                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.url

                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/openreflinklc', { data: { "Cn": data?.tc, "vpa": upiid }, cookie: '_ga=GA1.1.1268484901.1765174581; __gsas=ID=7f316d6307f0a672:T=1765174580:RT=1765174580:S=ALNI_MY2rwK_HvSU2DKNTpVXDixP6K2iLQ; __tad=1765174629.2366981; _ga_9K8ZFE4KNV=GS2.1.s1765174580$o1$g1$t1765174656$j59$l0$h0; upi_id=NzM2Mzg0MDI1MEBmYW0=; input=hhvtwhSzjYEpPPCpaHYQ%2BeijRqhWaoPKm8Ec71r90cGsU%2FxTVCSZpS9IMa6I4BleSL5M%2F8l90mrzH8gxaqE6p0xEkAG0SqXbfaaA0FWKsyyJLkjkzu0SZFOaNw1vZlsj2DERzT7oKlBVU4SniAkHnZEw%2FjCG7Yxa3olDVN6YT4yJqDowNziBLv6YTvTpgriliY6nonoDc7urAvoc95nX8Gtle9RvOek4708hklhq5gIYJiMZUDptWNxdzr4XA78yfuX7ScG43o7KmgPZjmR6%2FEPpmgZkD2lQHC4qM0hrPDM%3D' })

                    setredirectionurls(result1?.data?.data)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'ab150') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)

                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinklc', { "user_custom": useramount, "refer_custom": refamt, "vpa": "9283772628@ybl", "selected": "ab150-40-20-21894487-true-20", "channelName": "", "channelLink": "", "payment_mode": "true" })

                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.url

                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/openreflinklc', { data: { "Cn": data?.tc, "vpa": upiid }, cookie: '_ga=GA1.1.1268484901.1765174581; __gsas=ID=7f316d6307f0a672:T=1765174580:RT=1765174580:S=ALNI_MY2rwK_HvSU2DKNTpVXDixP6K2iLQ; __tad=1765174629.2366981; _ga_9K8ZFE4KNV=GS2.1.s1765174580$o1$g1$t1765174656$j59$l0$h0; upi_id=NzM2Mzg0MDI1MEBmYW0=; input=AYxuJFPxfZ8nz07bGqMNzvSTpFFFVqsVTfby1NkTu6rEc0bgRUXxHK%2BYKhJd9Wo9t0udWg5%2FDokl4MZn1vEOm%2Fzp5lEWuHyZdHUf2ckuMBTaseky%2BX0O3CFcaa%2FEPJuPJ8D5hgDA0Mmp%2FrJfMrupfv7JJvGBDxuUiMSbwoO7UCOZ1KgEVdf6CzVPx4JwjjYhB6blW1BVi%2BkVhE%2FFXFc9j67dyBwxG%2Fnj%2BpqiLNeyNlqQWaNnR1xeLdIAQQdZUDJHtf2VMbvqyhj3nSDcgyVYU3mCMwe9pOFYL9fbLKVGWog%3D' })

                    setredirectionurls(result1?.data?.data)
                    console.log(result1?.data, '11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'upstinst') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)

                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinklc', { "user_custom": useramount, "refer_custom": refamt, "vpa": "kashikdelhi297@aol", "selected": "upstinst-200-200-21672118-true-10", "channelName": "", "channelLink": "", "payment_mode": "true" })

                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.url

                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/openreflinklc', { data: { "Cn": data?.tc, "vpa": upiid }, cookie: '_ga=GA1.1.1268484901.1765174581; __gsas=ID=7f316d6307f0a672:T=1765174580:RT=1765174580:S=ALNI_MY2rwK_HvSU2DKNTpVXDixP6K2iLQ; __tad=1765174629.2366981; _ga_9K8ZFE4KNV=GS2.1.s1765174580$o1$g1$t1765174656$j59$l0$h0; input=A9g%2F9X%2F%2Fkfuqzs2GOThYFfUmh4rtj6XCmjKkR%2BLnOUcWgmHm713ykFMzm8v2bAixli34p%2FsVMyoD1%2F0X%2FKK1jVeUmlM%2FPEJJ31zPMXq%2FXm%2BOloJujbfL9p3ZXXgAvNDfm342NbA4tuS8tYutWNzJDUmA1oa8OD%2FQbcj0Zltr7Cwm%2BER%2F61jogkl43ZO2ye99f7fDPhCdfQ0K0VSQwTvCIgz01zY%2FwZ8YQ3NsSNLcniEu0CtjCmltCYW6AqT6puOYahDHr6ywQkLaulVm79t0uJiuclQnBkUo5kiVyf8Fn5ZJClEkV%2Fv35fYpv%2BgAwJ%2FQ; upi_id=OTIzMzE1MTc1NUBhcG8=' })

                    setredirectionurls(result1?.data?.data)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'nsn3d') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinklc', { "user_custom": useramount, "refer_custom": refamt, "vpa": "souravdas67@ptyms", "selected": "nsn3d-70-70-21806807-true-30", "channelName": "", "channelLink": "", "payment_mode": "true" })


                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.url

                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/openreflinklc', { data: { "Cn": data?.tc, "vpa": upiid }, cookie: '_ga=GA1.1.1268484901.1765174581; __gsas=ID=7f316d6307f0a672:T=1765174580:RT=1765174580:S=ALNI_MY2rwK_HvSU2DKNTpVXDixP6K2iLQ; __tad=1765174629.2366981; _ga_9K8ZFE4KNV=GS2.1.s1765174580$o1$g1$t1765174656$j59$l0$h0; upi_id=NzM2Mzg0MDI1MEBmYW0=; input=IHW6I1pIku69p%2F3CXugXbJuhfZyefFZewA3sjEH8kcNjpnys3FJhnrxxLescNE%2FxIq3vSSoSwRST9hHrAaMI8V6uG%2Bh37Yd%2FiOFRTgAcItXKW5pOjf%2Bh20u0j1ZxI2dLARqJdg5BMWNG6nRrHVjmXJM2jm1Y0D0ok07wFC10AHYqkW7aofcmOI0AeLwCF5R8hn3%2BHk15ALaahsbZXYIqT%2FbYmo8R1%2BSgcUNdMiFFvSRkAluhiJ9ZO4PFDELDxXE2C67tMJYIQ%2BumQYl3dMrigvwa2xBkc37M5I%2Bc1e9skUaO4HnaLXTGbLZ8vlJzcAx%2F' })

                    setredirectionurls(result1?.data?.data)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
        }
        else if (data?.partner == 'FC') {
            if (data?.tc == 'AirtelPB') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfc', {
                    'refcstmamo': useramount, "usrcstmamo": refamt, "cn": data?.tc, "number": upiid
                })
                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]

                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'Up') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfc', {
                    'refcstmamo': useramount, "usrcstmamo": refamt, "cn": data?.tc, "number": upiid
                })
                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]

                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'One') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfc', {
                    'refcstmamo': useramount, "usrcstmamo": refamt, "cn": data?.tc, "number": upiid
                })
                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]

                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'mXpr') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfc', {
                    'refcstmamo': useramount, "usrcstmamo": refamt, "cn": data?.tc, "number": upiid
                })
                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]



                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'bdmt') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfc', {
                    'refcstmamo': useramount, "usrcstmamo": refamt, "cn": data?.tc, "number": upiid
                })
                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]



                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'Gold') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfc', {
                    'refcstmamo': useramount, "usrcstmamo": refamt, "cn": data?.tc, "number": upiid
                })
                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]


                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'GoldExl') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfc', {
                    'refcstmamo': useramount, "usrcstmamo": refamt, "cn": data?.tc, "number": upiid
                })
                if (result?.data?.data?.status == "success") {
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]


                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'Campus') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const randomNumber = Math.floor(Math.random() * 900000000) + 100000000;
                const userupi = `9${randomNumber}@ybl`
                const result = await axios.post('http://localhost:8001/contact/genratereflinkfcsame', {
                    'refcstmamo': refamt, "usrcstmamo": useramount, "cn": data?.tc, "number": userupi, "number1": upiid
                })
                if (result?.data?.data?.status == "success") {
                    // console.log(result?.data?.data?.redirectUrl)
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]


                    setredirectionurls(temdata)
                    // console.log(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
            else if (data?.tc == 'Story') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const randomNumber = Math.floor(Math.random() * 900000000) + 100000000;
                const userupi = `9${randomNumber}@ybl`

                console.log(userupi)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkfcsame', {
                    'refcstmamo': refamt, "usrcstmamo": useramount, "cn": data?.tc, "number": userupi, "number1": upiid
                })
                if (result?.data?.data?.status == "success") {
                    // console.log(result?.data?.data?.redirectUrl)
                    const urllink = result?.data?.data?.redirectUrl
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]


                    setredirectionurls(temdata)
                    // console.log(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert('error on fecthing ref link')
                }



            }
        }
        else if (data?.partner == 'CN') {
            if (data?.tc == 'Airtel') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcn', {
                    'manualRefer': refamt, "manualUser": useramount, "payment_mode": 'instant', "vpa": upiid, offer: data?.offerid
                })

                if (result?.data?.data?.status) {
                    const urllink = result?.data?.data?.message
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]

                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

        }

        else if (data?.partner == 'CB') {
            if (data?.tc == 'Story-2') {
                try {
                    setredirectionurls([])
                    let useramount = Number(useramt)
                    let refamt = Number(data?.po - useramt)
                    const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcb?url=https://offer.campbolt.in/go.php', {
                        gateway: 2, "upi": upiid, camp: data?.tc
                    })

                    // console.log(result.data)

                    if (result?.data?.status) {

                        setredirectionurls(result?.data?.data)
                        // setIsPolling(true)
                        // callApi()
                        // setIsPolling(false)
                        // console.log(result1?.data,'11')



                    }
                    else {
                        alert('error on fecthing link')
                    }
                } catch (error) {
                    alert(error?.response.data)
                }





            }
            else if (data?.tc == 'Story-New') {
                try {
                    setredirectionurls([])
                    let useramount = Number(useramt)
                    let refamt = Number(data?.po - useramt)
                    const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcb?url=https://offer.campbolt.in/go.php', {
                        gateway: 2, "upi": upiid, camp: data?.tc
                    })

                    // console.log(result.data)

                    if (result?.data?.status) {

                        setredirectionurls(result?.data?.data)
                        // setIsPolling(true)
                        // callApi()
                        // setIsPolling(false)
                        // console.log(result1?.data,'11')



                    }
                    else {
                        alert('error on fecthing link')
                    }
                } catch (error) {
                    alert(error?.response.data)
                }





            }
            else if (data?.tc == 'Story-3') {
                try {
                    setredirectionurls([])
                    let useramount = Number(useramt)
                    let refamt = Number(data?.po - useramt)
                    const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinktm?url=https://trackmudra.in/offer/go.php', {
                        "upi": upiid, camp: 'story'
                    })

                    // console.log(result.data)

                    if (result?.data?.status) {

                        setredirectionurls(result?.data?.data)
                        // setIsPolling(true)
                        // callApi()
                        // setIsPolling(false)
                        // console.log(result1?.data,'11')



                    }
                    else {
                        alert('error on fecthing link')
                    }
                } catch (error) {
                    alert(error?.response.data)
                }





            }
            else if (data?.tc == 'Nielsen-Faro') {
                try {
                    setredirectionurls([])
                    let useramount = Number(useramt)
                    let refamt = Number(data?.po - useramt)
                    const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcbrefer', {
                        gateway: 2, "upi": upiid, offer: data?.tc, camp: data?.tc, urltg: '', user_payout: refamt, refer_payout: useramount, offerid: data?.offerid, refer: ''
                    })

                    // console.log(result.data)

                    if (result?.data?.status) {

                        setredirectionurls(result?.data?.data)
                        // setIsPolling(true)
                        // callApi()
                        // setIsPolling(false)
                        // console.log(result1?.data,'11')



                    }
                    else {
                        alert('error on fecthing link')
                    }
                } catch (error) {
                    alert(error?.response.data)
                }





            }

        }

        else if (data?.partner == 'CG') {
            if (data?.tc == 'Airtel') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcg', {
                    'refer': refamt, "user": useramount, "vpa": upiid, offer: data?.offer
                })

                console.log(result.data)

                if (result?.data?.status) {
                    const urllink = result?.data?.data
                    const gethostname = (url) => {
                        try {
                            var loc = new URL(url)
                            return loc.host
                        } catch (error) {

                        }
                    }

                    const temdata = [
                        { path: gethostname(urllink), url: urllink }
                    ]

                    setredirectionurls(temdata)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

        }
        else if (data?.partner == 'CL') {
            if (data?.tc == 'UP') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcl', {
                    'custom_refer': [{ "event": data?.goal, "userAmount": refamt, "myProfit": useramount }], "user": upiid, camp_id: data?.offerid, user_id: 1, code: data?.code
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }
            else if (data?.tc == 'navi') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcl', {
                    'custom_refer': [{ "event": data?.goal, "userAmount": refamt, "myProfit": useramount }], "user": upiid, camp_id: data?.offerid, user_id: 1, code: data?.code
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

            else if (data?.tc == 'credit') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcl', {
                    'custom_refer': [{ "event": data?.goal, "userAmount": refamt, "myProfit": useramount }], "user": upiid, camp_id: data?.offerid, user_id: 1, code: data?.code
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

        }
        else if (data?.partner == 'HQ') {

            if (data?.tc == 'incred') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkhq', {
                    "upi": upiid,
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

        }
        else if (data?.partner == 'CM') {

            if (data?.tc == 'incred') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('http://localhost:8001/contact/genratereflinkclickmudra', {
                    "upi": upiid, offerid: data?.offerid, useramt: useramount, refamt: refamt, goal: data?.goal
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

        }
        else if (data?.partner == 'CR') {

            if (data?.tc == 'vir') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcr', {
                    upi: upiid, offerid: data?.offerid, goal: data?.goal, refer: useramount, user: refamt
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }
            else if (data?.tc == 'faro') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcr', {
                    upi: upiid, offerid: data?.offerid, goal: data?.goal, refer: useramount, user: refamt
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }
            else if (data?.tc == 'airtel') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/genratereflinkcr', {
                    upi: upiid, offerid: data?.offerid, goal: data?.goal, refer: useramount, user: refamt
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

        }
        else if (data?.partner == 'PK') {

            if (data?.tc == '5paisa') {
                setredirectionurls([])
                let useramount = Number(useramt)
                let refamt = Number(data?.po - useramt)
                const result = await axios.post('http://localhost:8001/contact/genratereflinkpk', {
                    upi: upiid, offerid: data?.offerid, goal: data?.goal, user: useramount, refer: refamt
                })

                if (result?.data?.status) {



                    setredirectionurls(result?.data?.data)
                    // setIsPolling(true)
                    // callApi()
                    // setIsPolling(false)
                    // console.log(result1?.data,'11')



                } else {
                    alert(result.data?.data?.message)
                }



            }

        }

        setofferloading(false)
    }




    const callApi = async () => {

        setprocessloading(true)
        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000
        const clkid = sessionStorage.getItem('clickid')


        const data = offerlist?.filter((vl) => vl?.id == offerselctid)[0]



        if (data?.partner == 'LC') {
            const result = await axios.get(`https://reward-day-bg984.ondigitalocean.app/contact/checktxnstatuslc?cn=${data?.tc}&vpa=${upiid}`)

            const clkid = sessionStorage.getItem('clickid')


            if (result?.data?.data?.total_clicks > 0) {
                const clickidpart = redirectionurls[0]?.url?.split('&aff_click_id=')[1]

                const lastdata = result?.data?.data?.data?.filter((vl) => vl?.click_id == clickidpart)[0]
                // console.log(lastdata)


                if (lastdata) {
                    const events = lastdata?.events[1]
                    if (events?.status == "true") {
                        setprocessloading(false)
                        seteventstatus(true)
                        if (lastdata?.cbstatus == false) {
                            const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000
                            let tempdata = { ...lastdata, clickid: clkid, upiid: upiid, upiidname, event1: false, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                            // console.log(tempdata)
                            const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                            setIsPolling(false)
                            navigate(`/trk/success/${bankid}`)


                        }
                    }


                }

            }
            // console.log('call api 2 sec')
        }
        if (data?.partner == 'FC') {

            const result = await axios.get(`https://reward-day-bg984.ondigitalocean.app/contact/checktxnstatusfc?cn=${data?.tc}&vpa=${upiid}&offerid=${data?.offerid}`)

            const clkid = sessionStorage.getItem('clickid')




            if (result?.data?.data?.clicks > 0) {
                const clickidpart = redirectionurls[0]?.url?.split('click_id=')[1]
                // const clickidpart = '9501492f09ea4476b4ef71e85ab4e628'

                console.log('prev')

                const lastdata = result?.data?.data?.data?.filter((vl) => vl?.click == clickidpart && vl?.old_event == data?.goal)[0]
                // console.log(lastdata, 'last')

                // console.log(isPolling, 'ispo')


                if (lastdata) {

                    if (lastdata?.status == "Approved") {
                        setprocessloading(false)
                        seteventstatus(true)
                        if (lastdata?.referPaymentStatus == 'ACCEPTED') {


                            let tempdata = { ...lastdata, clickid: clkid, upiid: upiid, upiidname, event1: false, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                            // console.log(tempdata)
                            const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                            // console.log(result?.data)

                            setIsPolling(false)
                            navigate(`/trk/success/${bankid}`)


                        }
                    }


                }

            }


            // console.log('call api 2 sec')
        }
    }




    useEffect(() => {
        if (isPolling) {
            // Start the interval and save its ID
            intervalRef.current = setInterval(() => {
                // setCount(count+2)
                callApi();
            }, 2000); // 2000 milliseconds = 2 seconds
        } else {
            // Clear the interval when polling stops or component unmounts
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        }

        // Cleanup function to clear interval when component unmounts
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isPolling])

    const [btnload, setbtnload] = useState(false)
    // console.log(redirectionurls)

    const handleprocedpay = async () => {

        setpostbackmsg('')
        setprocessloading(true)
        const data = offerlist?.filter((vl) => vl?.id == offerselctid)[0]
        if (data?.partner == 'LC') {
            if (data?.tc == 'Aone') {
                const linkurl = redirectionurls[1]?.url?.split('&sub1=')[1]
                const final = linkurl?.split('&sub2')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);
                setTimeout(async () => {
                    const result = await axios.get(postbackurl)
                    setpostbackmsg(result.data?.message)
                    setIsPolling(true)
                    callApi()
                    setbtnload(false)
                    console.log('call after 10 sec')
                }, 10000);

                // setIsPolling(false)
            }
            else if (data?.tc == 'Atl') {
                const final = redirectionurls[1]?.url?.split('&aff_sub=')[1]
                // const final = linkurl?.split('&sub2')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);
                setTimeout(async () => {

                    const result = await axios.get(postbackurl)
                    setpostbackmsg(result.data?.message)
                    setIsPolling(true)
                    callApi()
                    setbtnload(false)
                    console.log('call after 10 sec')
                }, 10000);

                // setIsPolling(false)
            }
            else if (data?.tc == 'ab150') {
                const final = redirectionurls[1]?.url?.split('&aff_sub=')[1]
                // const final = linkurl?.split('&sub2')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);
                setTimeout(async () => {

                    const result0 = await axios.get(`https://lootcampaign.o18.click/p?o=21894487&m=7916&auth_token=ce82c12606&tid=${final}`)
                    const result01 = await axios.get(`https://lootcampaign.o18.click/p?o=21894487&m=7916&event=Register&auth_token=ce82c12606&tid=${final}`)

                    const result = await axios.get(postbackurl)
                    setpostbackmsg(result.data?.message)
                    setIsPolling(true)
                    setbtnload(false)
                    callApi()
                    console.log('call after 10 sec')
                }, 10000);

                // setIsPolling(false)
            }
            else if (data?.tc == 'upstinst') {
                const linkurl = redirectionurls[1]?.url?.split('&p1=')[1]
                const final = linkurl?.split('&source')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)

                setsefclickid(final)
                setTimeout(async () => {
                    const result = await axios.get(postbackurl)
                    setpostbackmsg(result.data?.message)
                    setIsPolling(true)
                    callApi()
                    console.log('call after 10 sec')
                }, 15000);
                // const result = await axios.get('https://lootcampaign.o18.click/p?o=21672118&m=7916&auth_token=ce82c12606&tid=D-21769171-1766631605-73648734')
                // setpostbackmsg(result.data?.message)
                // setIsPolling(true)
                // callApi()
                // setIsPolling(false)
            }
            else if (data?.tc == 'nsn3d') {
                const linkurl = redirectionurls[1]?.url?.split('&p1=')[1]
                const final = linkurl?.split('&source')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)

                setsefclickid(final)


                setTimeout(async () => {


                    const result = await axios.get(postbackurl)
                    setpostbackmsg(result.data?.message)
                    setIsPolling(true)
                    callApi()
                    console.log('call after 10 sec')
                }, 15000);
                // const result = await axios.get('https://lootcampaign.o18.click/p?o=21672118&m=7916&auth_token=ce82c12606&tid=D-21769171-1766631605-73648734')
                // setpostbackmsg(result.data?.message)
                // setIsPolling(true)
                // callApi()
                // setIsPolling(false)
            }

        }
        else if (data?.partner == 'FC') {

            if (data?.tc == 'AirtelPB') {
                const final = redirectionurls[0]?.url?.split('click_id=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/installdone1231231?click=${final}` })

                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    setIsPolling(true)
                    callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 10000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'Up') {
                const final = redirectionurls[0]?.url?.split('&source=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/install?click=${final}` })

                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    setIsPolling(true)
                    callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 10000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'One') {
                const final1 = redirectionurls[0]?.url?.split('&sub1=')[1]
                const final = final1?.split('&sub3=')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/install?click=${final}` })

                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    setIsPolling(true)
                    callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 10000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'mXpr') {
                const final = redirectionurls[0]?.url?.split('&source=')[1]

                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel3.logicpay.in/api/v1/postback/e1cca49a-6e5c-415c-9728-ed6aeadd4981/register?click=${final}&pass=93nbs7373` })

                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    console.log(result?.data)
                    if (result?.data?.data?.status == true) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)

                    }
                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 10000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'bdmt') {
                const final = redirectionurls[0]?.url?.split('&aff_sub=')[1]

                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);


                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    console.log(result?.data)
                    if (result?.data?.data?.status == true) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)

                    }
                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 8000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'Gold') {
                const final = redirectionurls[0]?.url?.split('&aff_sub=')[1]

                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/installtracked?click=${final}` })


                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    console.log(result?.data)
                    if (result?.data?.data?.status == true) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)

                    }
                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 8000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'GoldExl') {
                const final = redirectionurls[0]?.url?.split('&aff_sub=')[1]

                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/installtracked?click=${final}` })


                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    console.log(result?.data)
                    if (result?.data?.data?.status == true) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)

                    }
                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 8000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'Campus') {
                const final = redirectionurls[0]?.url?.split('&s1=')[1]

                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                // const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/installdone?click=${final}` })


                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    console.log(result?.data)
                    if (result?.data?.data?.status == true) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)

                    }
                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 8000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'Story') {
                const final = redirectionurls[0]?.url?.split('?subid=')[1]

                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                setbtnload(true)
                sessionStorage.setItem('clickid', final);

                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://panel4.logicpay.in/api/v1/postback/fbac5dc1-1daf-4fa1-adc0-c32806166bdc/install?click=${final}` })


                setTimeout(async () => {
                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })
                    setpostbackmsg(result?.data?.data?.msg)
                    console.log(result?.data)
                    setprocessloading(true)
                    setTimeout(async () => {
                        if (result?.data?.data?.status == true) {
                            setprocessloading(false)
                            const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                            let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                            // console.log(tempdata)
                            const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                            // console.log(result?.data)
                            console.log('15sec')
                            setIsPolling(false)
                            navigate(`/trk/success/${bankid}`)

                        }
                    }, 22000);
                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 8000);


                // setIsPolling(false)
            }
        }
        else if (data?.partner == 'CN') {

            if (data?.tc == 'Airtel') {
                const checkoptim = redirectionurls[0]?.url?.includes('optimidea.gotrackier.com')
                if (checkoptim) {
                    const final = redirectionurls[0]?.url?.split('source=')[1]
                    const postbackurl = data?.postback?.replace('{clickid}', final)
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);

                    setbtnload(true)
                    const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://proproonline.cashnest.in/?click_id=${final}&event=install&token=P360RqhwkwoeRQgTriaL` })
                    setTimeout(async () => {



                        const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://proproonline.cashnest.in/?click_id=${final}&event=Account_Open&token=P360RqhwkwoeRQgTriaL` })

                        console.log(result.data)
                        if (result?.data?.data?.status == false) {
                            setpostbackmsg(result?.data?.data?.message)

                        } else {

                            const tempmsg1 = result?.data?.data?.split('REFER Pay API Response :</b> ')[1]
                            const temmsg2 = tempmsg1?.split('<hr>')[0]

                            const jsodata = JSON.parse(temmsg2)
                            console.log(jsodata)

                            if (jsodata?.status == 'success') {
                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, click_id: jsodata?.utr, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                                // console.log(result?.data)

                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                            }
                            else if (jsodata?.status == "pending") {
                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, click_id: jsodata?.utr, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                                // console.log(result?.data)

                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                            }
                            else {
                                alert('Payment failed')
                            }
                        }


                        // setIsPolling(true)
                        // callApi()
                        console.log('call after 10 sec')
                        setbtnload(false)
                    }, 10000);

                } else {


                    const final = redirectionurls[0]?.url?.split('aff_sub=')[1]
                    const postbackurl = data?.postback?.replace('{clickid}', final)
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);

                    setbtnload(true)
                    const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://proproonline.cashnest.in/?click_id=${final}&event=install&token=P360RqhwkwoeRQgTriaL` })
                    setTimeout(async () => {



                        const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                        console.log(result.data)
                        if (result?.data?.data?.status == false) {
                            setpostbackmsg(result?.data?.data?.message)

                        } else {

                            const tempmsg1 = result?.data?.data?.split('REFER Pay API Response :</b> ')[1]
                            const temmsg2 = tempmsg1?.split('<hr>')[0]

                            const jsodata = JSON.parse(temmsg2)
                            console.log(jsodata)

                            if (jsodata?.status == 'success') {
                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, click_id: jsodata?.utr, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                                // console.log(result?.data)

                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                            } else {
                                alert('Payment failed')
                            }
                        }


                        // setIsPolling(true)
                        // callApi()
                        console.log('call after 10 sec')
                        setbtnload(false)
                    }, 10000);
                }

                // setIsPolling(false)
            }
        }
        else if (data?.partner == 'CL') {

            if (data?.tc == 'UP') {
                const final = redirectionurls[2]?.url?.split('source=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)
                const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://cashlootcamps.com/acquisition/?security_token=vp41H2irdVsR&event_name=InstallTracked&click_id=${final}` })
                setTimeout(async () => {



                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    console.log(result.data)

                    const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                    let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                    // console.log(tempdata)
                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                    // console.log(result?.data)

                    setIsPolling(false)
                    navigate(`/trk/success/${bankid}`)




                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 5000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'navi') {
                const final = redirectionurls[2]?.url?.split('aff_sub=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)
                // const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://cashlootcamps.com/acquisition/?security_token=vp41H2irdVsR&event_name=InstallTracked&click_id=${final}` })
                setTimeout(async () => {



                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    console.log(result.data)

                    const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                    let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                    // console.log(tempdata)
                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                    // console.log(result?.data)

                    setIsPolling(false)
                    navigate(`/trk/success/${bankid}`)




                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 5000);


                // setIsPolling(false)
            }
            else if (data?.tc == 'credit') {
                const final = redirectionurls[2]?.url?.split('aff_sub=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)
                // const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://cashlootcamps.com/acquisition/?security_token=vp41H2irdVsR&event_name=InstallTracked&click_id=${final}` })
                setTimeout(async () => {



                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    console.log(result.data)

                    const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                    let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                    // console.log(tempdata)
                    const result1 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                    // console.log(result?.data)

                    setIsPolling(false)
                    navigate(`/trk/success/${bankid}`)




                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 5000);


                // setIsPolling(false)
            }
        }
        else if (data?.partner == 'CB') {
            if (data?.tc == 'Story-2') {

                if (redirectionurls[2]?.url?.includes('digirevomedia')) {

                    const final1 = redirectionurls[3]?.url?.split('clickid=')[1]
                    const final = final1?.split('&advertising_id=')[0]
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);
                    setbtnload(true)
                    setTimeout(async () => {
                        const result11 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://digirevomedia.jump2cloud.org/track?click_id=${final}`, headers: { 'cf-connecting-ip': '45.92.116.203' } }).then((resss) => {
                            setTimeout(async () => {
                                const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://digirevomedia.jump2cloud.org/track?click_id=${final}&goal_id=102`, headers: { 'cf-connecting-ip': '45.92.116.203' } })

                                // console.log(result.data)

                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result01 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)
                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                                console.log('call after 10 sec')
                                setbtnload(false)
                            }, 2000);

                        }).catch((e) => {
                            setbtnload(false)
                            alert('some error ip error')
                        })
                    }, 30000);

                } else {
                    const final = redirectionurls[2]?.url?.split('sub1=')[1]
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);
                    setbtnload(true)


                    setTimeout(async () => {
                        const result11 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://www.a2zf.com/track/install-postback.asp?txnId=${final}` }).then((resss) => {
                            setTimeout(async () => {
                                const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://a2zf.com/track/track-event.asp?txnId=${final}&event=424` })

                                // console.log(result.data)

                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result01 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)
                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                                console.log('call after 10 sec')
                                setbtnload(false)
                            }, 2000);

                        }).catch((e) => {
                            setbtnload(false)
                            alert('some error ip error')
                        })
                    }, 30000);
                }
            }
            else if (data?.tc == 'Story-New') {

                if (redirectionurls[2]?.url?.includes('digirevomedia')) {

                    const final1 = redirectionurls[3]?.url?.split('clickid=')[1]
                    const final = final1?.split('&advertising_id=')[0]
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);
                    setbtnload(true)
                    setTimeout(async () => {
                        const result11 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://digirevomedia.jump2cloud.org/track?click_id=${final}`, headers: { 'cf-connecting-ip': '45.92.116.203' } }).then((resss) => {
                            setTimeout(async () => {
                                const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://digirevomedia.jump2cloud.org/track?click_id=${final}&goal_id=102`, headers: { 'cf-connecting-ip': '45.92.116.203' } })

                                // console.log(result.data)

                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result01 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)
                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                                console.log('call after 10 sec')
                                setbtnload(false)
                            }, 2000);

                        }).catch((e) => {
                            setbtnload(false)
                            alert('some error ip error')
                        })
                    }, 30000);

                } else {
                    const final = redirectionurls[2]?.url?.split('sub1=')[1]
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);
                    setbtnload(true)


                    setTimeout(async () => {
                        const result11 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://www.a2zf.com/track/install-postback.asp?txnId=${final}` }).then((resss) => {
                            setTimeout(async () => {
                                const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://a2zf.com/track/track-event.asp?txnId=${final}&event=424` })

                                // console.log(result.data)

                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result01 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)
                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                                console.log('call after 10 sec')
                                setbtnload(false)
                            }, 2000);

                        }).catch((e) => {
                            setbtnload(false)
                            alert('some error ip error')
                        })
                    }, 30000);
                }
            }
            else if (data?.tc == 'Story-3') {

                if (redirectionurls[2]?.url?.includes('digirevomedia')) {

                    const final1 = redirectionurls[3]?.url?.split('clickid=')[1]
                    const final = final1?.split('&advertising_id=')[0]
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);
                    setbtnload(true)
                    setTimeout(async () => {
                        const result11 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://digirevomedia.jump2cloud.org/track?click_id=${final}`, headers: { 'cf-connecting-ip': '45.92.116.203' } }).then((resss) => {
                            setTimeout(async () => {
                                const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://digirevomedia.jump2cloud.org/track?click_id=${final}&goal_id=102`, headers: { 'cf-connecting-ip': '45.92.116.203' } })

                                // console.log(result.data)

                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result01 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)
                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                                console.log('call after 10 sec')
                                setbtnload(false)
                            }, 2000);

                        }).catch((e) => {
                            setbtnload(false)
                            alert('some error ip error')
                        })
                    }, 30000);

                } else {
                    const final = redirectionurls[2]?.url?.split('sub1=')[1]
                    setsefclickid(final)
                    sessionStorage.setItem('clickid', final);
                    setbtnload(true)


                    setTimeout(async () => {
                        const result11 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://www.a2zf.com/track/install-postback.asp?txnId=${final}` }).then((resss) => {
                            setTimeout(async () => {
                                const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://a2zf.com/track/track-event.asp?txnId=${final}&event=424` })

                                // console.log(result.data)

                                const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                                let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                                // console.log(tempdata)
                                const result01 = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)
                                setIsPolling(false)
                                navigate(`/trk/success/${bankid}`)
                                console.log('call after 10 sec')
                                setbtnload(false)
                            }, 2000);

                        }).catch((e) => {
                            setbtnload(false)
                            alert('some error ip error')
                        })
                    }, 30000);
                }







            }
        }
        else if (data?.partner == 'CG') {

            if (data?.tc == 'Airtel') {
                const final = redirectionurls[0]?.url?.split('aff_sub=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)
                const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://partners.cashgullak.com/api/webhook/conversion?webhook_secret=cqUyz0Sg9G&click_id=${final}&event=ins` })
                setTimeout(async () => {



                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    console.log(result.data)
                    if (result?.data?.data?.status == false) {
                        setpostbackmsg(result?.data?.data?.message)

                    } else {

                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)

                    }


                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 10000);

                // setIsPolling(false)
            }
        }
        else if (data?.partner == 'HQ') {

            if (data?.tc == 'incred') {
                const final1 = redirectionurls[2]?.url?.split('click_id=')[1]
                const final = final1?.split('&')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)
                const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://sandboxads.fuse-cloud.com/pb?tid=${final}` })

                const result22 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://sandboxads.fuse-cloud.com/pb?tid=${final}&e_tkn=SignupComplete` })

                setTimeout(async () => {



                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    setpostbackmsg(result?.data?.data)
                    console.log(result?.data)

                    if (result?.data?.data == 'conversion_status=Approved; con_msg=Success;') {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)


                    } else {
                        alert('failed')


                    }


                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 10 sec')
                    setbtnload(false)
                }, 2000);

                // setIsPolling(false)
            }
        }
        else if (data?.partner == 'CR') {

            if (data?.tc == 'vir') {
                const final = redirectionurls[1]?.url?.split('aff_sub=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)




                setTimeout(async () => {

                    const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://api.trackexdeal.com/track/postback/?clickid=${final}&eventKey=Default&key=cd3ad5f72b4a0d5ac934762531559aa9` })


                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    setpostbackmsg(result?.data?.data?.message)
                    console.log(result?.data)

                    if (result?.data?.data?.status) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)


                    } else {
                        alert('failed')


                    }


                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 25 sec')
                    setbtnload(false)
                }, 25000);

                // setIsPolling(false)
            }
            else if (data?.tc == 'faro') {
                const final1 = redirectionurls[1]?.url?.split('p1=')[1]
                const final = final1?.split('&source')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)




                setTimeout(async () => {

                    const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://api.trackexdeal.com/track/postback/?clickid=${final}&eventKey=Install&key=65417183746e742a40507f9c3f76dccc` })


                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    setpostbackmsg(result?.data?.data?.message)
                    console.log(result?.data)

                    if (result?.data?.data?.status) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)


                    } else {
                        alert('failed')


                    }


                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 25 sec')
                    setbtnload(false)
                }, 28000);

                // setIsPolling(false)
            }
            else if(data?.tc == 'airtel') {
                const final = redirectionurls[1]?.url?.split('aff_sub=')[1]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)




                setTimeout(async () => {

                    const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://api.trackexdeal.com/track/postback/?clickid=${final}&eventKey=Default&key=cd3ad5f72b4a0d5ac934762531559aa9` })


                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl })

                    setpostbackmsg(result?.data?.data?.message)
                    console.log(result?.data)

                    if (result?.data?.data?.status) {
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)


                    } else {
                        alert('failed')


                    }


                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 25 sec')
                    setbtnload(false)
                }, 55000);

                // setIsPolling(false)
            }
        }
        else if (data?.partner == 'PK') {

            if (data?.tc == '5paisa') {
                const final1 = redirectionurls[2]?.url?.split('p1=')[1]
                const final = final1?.split('&source=')[0]
                const postbackurl = data?.postback?.replace('{clickid}', final)
                setsefclickid(final)
                sessionStorage.setItem('clickid', final);

                setbtnload(true)

                const result0 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://jmglobalmedia.jump2cloud.org/track?click_id=${final}&offer_id=541&token=12577f2ab600a5fcde8d` })
                const result1 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://jmglobalmedia.jump2cloud.org/track?click_id=${final}&offer_id=541&goal_id=234&token=12577f2ab600a5fcde8d` })
                const result2 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://jmglobalmedia.jump2cloud.org/track?click_id=${final}&offer_id=541&goal_id=235&token=12577f2ab600a5fcde8d` })
                const result3 = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://jmglobalmedia.jump2cloud.org/track?click_id=${final}&offer_id=541&goal_id=236&token=12577f2ab600a5fcde8d` })


                setTimeout(async () => {

                    const result = await axios.post(`https://reward-day-bg984.ondigitalocean.app/contact/callbackfc`, { postbackurl: `https://jmglobalmedia.jump2cloud.org/track?click_id=${final}&offer_id=541&goal_id=237&token=12577f2ab600a5fcde8d` })


                    console.log(result?.data)

                    if (result?.data?.success == 'Conversion Recorded Successfully!') {
                        setpostbackmsg(result?.data?.success)
                        const bankid = Math.floor(Math.random() * (999999999999 - 100000000000 + 1)) + 100000000000

                        let tempdata = { clickid: final, upiid: upiid, upiidname, event1: true, event2: true, usercb: Number(useramt), refcb: Number(data?.po - useramt), partner: data?.partner, campaign: data?.tc, bankid: bankid }
                        // console.log(tempdata)
                        const result = await axios.post('https://reward-day-bg984.ondigitalocean.app/contact/createtricktcn', tempdata)

                        // console.log(result?.data)

                        setIsPolling(false)
                        navigate(`/trk/success/${bankid}`)

                    } else {
                        setpostbackmsg(result?.data?.message)
                        alert('failed')
                    }
                    // setIsPolling(true)
                    // callApi()
                    console.log('call after 8 sec')
                    setbtnload(false)
                }, 8000);

                // setIsPolling(false)
            }

        }

        setprocessloading(false)

    }







    return (
        <div style={{ marginTop: 10, height: '100vh', width: '100%', justifyItems: 'center' }}>

            {/* <button onClick={() => setIsPolling(false)}>off</button> */}

            <div>
                {!upiid?.length ? <Button onClick={() => setopenbtn(!openbtn)} type="primary">Scan QR</Button> : null}
            </div>

            <div style={{ marginTop: 8, marginBottom: 8 }}>
                {!upiid?.length ? <Space.Compact style={{ width: '100%' }}>
                    <Input placeholder="UPI ID" onChange={(e) => setinputupi(e.target.value)} />
                    <Button loading={loadingupive} onClick={handleclickupiset} type="primary">Submit</Button>
                </Space.Compact> : null}
            </div>

            {
                openbtn ? <div className="App" style={{ textAlign: 'center', padding: '20px', width: '100%', }}>

                    {scannedData ? (
                        <div>
                            {/* <h2></h2> */}

                        </div>
                    ) : (
                        <Qrscancamera onScanSuccess={handleScanSuccess} />
                    )}
                </div> : null
            }





            {upiidname ? <div style={{ width: '100%' }} >

                <div style={{ backgroundColor: 'white', margin: 10, padding: 10, paddingBottom: 15, paddingTop: 15, borderRadius: 10 }}>



                    <div style={{}}>
                        <p style={{ fontWeight: 'bold' }}>{upiidname}</p>
                        <p style={{ fontSize: 12 }}>{upiid}</p>

                    </div>


                    <div style={{ marginTop: 20, display: 'flex' }}>
                        <p style={{ fontWeight: 'bold', fontSize: 28 }}>₹</p>
                        <Input onChange={(e) => setuseramt(e?.target?.value)} type={'number'} style={{ fontWeight: 'bold', fontSize: 33 }} size='large' placeholder="0" variant="borderless" />
                    </div>

                    <div style={{ marginTop: 20, display: 'flex' }}>
                        <Select
                            loading={offerloading}
                            placeholder='Select '
                            style={{ width: 333 }}
                            onChange={handleofferchnage}
                            options={offerlist?.map(vl => (
                                {
                                    label: `${vl?.name} - ${vl?.po}₹ ${vl?.time?`-Time(${vl?.time}sec)`:''} ${vl.isfixed ? ' (Fix)' : ''}`, value: vl?.id
                                }
                            ))}
                        />
                    </div>


                    {
                        redirectionurls?.length ? <div style={{ marginTop: 10, justifyContent: 'center' }}>
                            {redirectionurls?.map((vl) => (
                                <span style={{ fontSize: 10, alignItems: 'center' }}> {vl?.path} --  </span>
                            ))}

                            {
                                postbackmsg ? <p>{postbackmsg}</p> : null
                            }

                            <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Button loading={processloading} onClick={handleprocedpay} type="primary" size="large" >
                                    Proceed to Pay
                                </Button>
                                {btnload ? <ClockLoader
                                    color='black'
                                    // loading={btnload}
                                    size={20}
                                    aria-label="Loading Spinner"
                                    data-testid="loader"
                                /> : null}


                            </div>

                            {
                                postbackmsg ? <div> <div style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}>
                                    <Button size='large' type="dashed" loading={!eventstatus}>
                                        <img style={{ width: 25 }} src={eventstatus ? 'https://offers.fokatcash.com/Images/%E2%80%94Pngtree%E2%80%943d%20green%20check%20icon%20in_8926850%203%20(2).png' : 'https://lootcampaign.in/tracker/images/pending_12196745%201%20(2)%20(1).png'} />
                                    </Button>

                                </div>
                                    <p style={{ textAlign: 'center', fontSize: 12 }}>Wait for 1 min</p>
                                </div> : null
                            }

                        </div> : null
                    }



                </div>




            </div> : null}










        </div>
    )
}

export default Qrscan1